'use strict';

export default function (AlpineInstance) {
    AlpineInstance.magic('parent', (el, { Alpine }) => {
        return Alpine.mergeProxies(
            Alpine.closestDataStack(el).slice(1),
        );
    });
}
